import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import * as ExpeditionProcessService from "../../../../services/expeditionProcessService";
import { useReadBigBag } from "../../standAloneProcess/hook/useReadBigBag";
import ExpeditionProcessDetailView from "./expeditionProcessDetail.view";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import * as XLSX from "xlsx";
import moment from "moment-timezone";
import {
  PROCESS_EXPEDITION_CLOSED,
  PROCESS_EXPEDITION_OPEN,
  PROCESS_EXPEDITION_STARTED,
} from "../../../../constants";
import * as StockService from "../../../../services/StockServices";
import InputPassObjects from "./InputPassObjects";
import Breadcrumb from "../../../utils/breadCrumbs";
import { TitleJunction } from "./expeditionProcessDetail.styled";

const InventaryDetailContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  // const { simpleReadBigBag, initial } = useReadBigBag();
  const [refresh, setRefresh] = useState(false);
  const [items, setItems] = useState([]);
  const [stocksSeleccionados, setStocksSeleccionados] = useState([]);
  const [resetKey, setResetKey] = useState(0);
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.expeditionProcess.title"), path: PATHS.EXPEDITION_LIST },
    { label: t("forms.expeditionDetail.title") },
  ];
  const { simpleReadBigBag, initial } = useReadBigBag();

  useEffect(() => {
    const loadData = async () => {
      ExpeditionProcessService.processGetService(uuid).then((result) => {
        setData(result);
      });

      const stockItems = await StockService.listAllStocks(uuid);
      setItems(stockItems);
    };

    loadData();
  }, [uuid]);

  useEffect(() => {
    if (refresh) {
      const reloadData = async () => {
        const result = await ExpeditionProcessService.processGetService(uuid);
        setData(result);

        const stockItems = await StockService.listAllStocks(uuid);
        setItems(stockItems);
        setStocksSeleccionados([]);
        setResetKey((prev) => prev + 1);
        setRefresh(false);
      };

      reloadData();
    }
  }, [refresh, uuid]);

  const handlerOnCancel = () => {
    navigate(PATHS.EXPEDITION_DETAIL);
  };

  const handlerOnSave = async () => {
    try {
      let result = await ExpeditionProcessService.addBBs(
        stocksSeleccionados,
        data.uuid,
      );

      let title = "";
      let text = "";
      let icon = "";
      if (result) {
        title = t("forms.expeditionDetail.messages.registerBB.title");
        text = t("forms.expeditionDetail.messages.registerBB.success");
        icon = "success";
      } else {
        title = "Error";
        text = t("forms.expeditionDetail.messages.registerBB.error");
        icon = "error";
      }
      showDialog(title, text, icon, false, "OK", false);
      setRefresh(true);
    } catch (error) {
      const errorCode = error.data.error.code;
      let errorMsg;
      if (errorCode === "EXPEDITION.CREATE.TOTAL_EXCEEDED") {
        errorMsg = t("forms.expeditionDetail.messages.totalExceeded.error");
      } else {
        errorMsg = t("forms.expeditionDetail.messages.addBigBag.errorComun");
      }

      showDialog("Error", errorMsg, "error", false, "OK", false);
    }
  };

  const handlerOnFinish = async () => {
    let title = t("forms.expeditionProcess.dialog.closeProcess.title");
    let text = t("forms.expeditionProcess.dialog.closeProcess.text");

    let okAction = async () => {
      try {
        let result = await ExpeditionProcessService.modifyStatusProcess(
          data.uuid,
          { status: PROCESS_EXPEDITION_CLOSED.code },
        );

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          title = t("forms.expeditionProcess.messages.finish.title");
          text = t("forms.expeditionProcess.messages.finish.success");
          icon = "success";
          showDialog(title, text, icon, false, "OK", false, () => {
            setRefresh(true);
          });
        } else {
          title = "Error";
          text = t("forms.expeditionProcess.messages.finish.error");
          icon = "error";
          showDialog(title, text, icon, false, "OK", false);
        }
      } catch (error) {
        // const errorCode = error.data.error.code;
        // let errorMsg;
        // let title = "Error";
        // let icon = "error";
        // if (errorCode === "DATE.ERROR") {
        //   errorMsg = t("forms.expeditionProcess.messages.finish.dateError");
        // } else {
        //   errorMsg = t("forms.expeditionProcess.messages.finish.error");
        // }
        // showDialog(title, errorMsg, icon, false, "OK", false);
      }
    };

    const cancelAction = () => {};

    showDialog(
      title,
      text,
      "warning",
      true,
      t("forms.inventary.dialog.closeProcess.buttonOk"),
      false,
      okAction,
      t("forms.inventary.dialog.closeProcess.buttonNo"),
      cancelAction,
    );
  };

  const handlerOnInit = async () => {
    let title = t("forms.expeditionProcess.dialog.initProcess.title");
    let text = t("forms.expeditionProcess.dialog.initProcess.text");

    let okAction = async () => {
      try {
        let result = await ExpeditionProcessService.modifyStatusProcess(
          data.uuid,
          { status: PROCESS_EXPEDITION_STARTED.code },
        );

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          title = t("forms.expeditionProcess.messages.init.title");
          text = t("forms.expeditionProcess.messages.init.success");
          icon = "success";
          showDialog(title, text, icon, false, "OK", false, () => {
            setRefresh(true);
          });
        } else {
          title = "Error";
          text = t("forms.expeditionProcess.messages.init.error");
          icon = "error";
          showDialog(title, text, icon, false, "OK", false);
        }
      } catch (error) {
        const errorCode = error.data.error.code;
        let errorMsg;
        let title = "Error";
        let icon = "error";

        if (errorCode === "DATE.ERROR") {
          errorMsg = t("forms.expeditionProcess.messages.init.dateError");
        } else {
          errorMsg = t("forms.expeditionProcess.messages.init.error");
        }

        showDialog(title, errorMsg, icon, false, "OK", false);
      }
    };

    const cancelAction = () => {};

    showDialog(
      title,
      text,
      "warning",
      true,
      t("forms.expeditionProcess.dialog.initProcess.buttonOk"),
      false,
      okAction,
      t("forms.expeditionProcess.dialog.initProcess.buttonNo"),
      cancelAction,
    );
  };

  // const exportToExcel = async () => {
  //   InventaryService.listToExport(data.uuid).then((result) => {
  //     const data = result.map((item) => {
  //       // const statusStock = STOCK_STATUS.find((c) => c.code === stock.status);
  //       return {
  //         A: item.batch,
  //         B: item.numArticle,
  //         C: item.descriptionArticle,
  //         D: item.weight,
  //         E: moment(item.date).format("DD-MM-yyyy HH:mm"),
  //         F: item.userToInventary.email,
  //         G: item.existingStock ? "En existencias" : "No hay Stock",
  //       };
  //     });
  //     data.unshift({
  //       A: "Lote",
  //       B: "nº Artículo",
  //       C: "Descripción Artículo",
  //       D: "Peso (Kg)",
  //       E: "Fecha",
  //       F: "Usuario",
  //       G: "Stock",
  //     });

  //     const filename = `Inventary_export_${moment(new Date()).format(
  //       "DDMMyyyyHHmm"
  //     )}`;
  //     const sheetName = "Listado de Inventario";
  //     var ws = XLSX.utils.json_to_sheet(data, {
  //       header: ["A", "B", "C", "D", "E", "F", "G"],
  //       skipHeader: true,
  //       UTC: true,
  //       dateNF: "dd-mm-yyyy hh:mm;@",
  //     });
  //     // dateNF:'mm/dd/yyyy;@',cellDates:true, raw: true}
  //     const wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, sheetName);
  //     XLSX.writeFile(wb, filename + ".xlsx");
  //   });
  // };
  const inventary = true;

  const handleStocksChange = useCallback((seleccionados) => {
    setStocksSeleccionados(seleccionados);
  }, []);

  const handleDelete = useCallback(async (batch) => {
    try {
      const result = await ExpeditionProcessService.deleteItemProcess(batch);
      console.log(result);
      if (result) {
        setRefresh(true);
      }
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  }, []);

  const handlerBack = () => {
    navigate(PATHS.EXPEDITION_LIST);
  };

  const handlerOnPausedExpedition = async () => {
    let title = t("forms.expeditionProcess.dialog.pausedExpedition.title");
    let text = t("forms.expeditionProcess.dialog.pausedExpedition.text");

    let okAction = async () => {
      try {
        let result = await ExpeditionProcessService.modifyStatusProcess(
          data.uuid,
          { status: PROCESS_EXPEDITION_OPEN.code },
        );

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          title = t("forms.expeditionProcess.messages.pausedExpedition.title");
          text = t("forms.expeditionProcess.messages.pausedExpedition.success");
          icon = "success";
          showDialog(title, text, icon, false, "OK", false, () => {
            setRefresh(true);
          });
        } else {
          title = "Error";
          text = t("forms.expeditionProcess.messages.pausedExpedition.error");
          icon = "error";
          showDialog(title, text, icon, false, "OK", false);
        }
      } catch (error) {
        const errorCode = error.data.error.code;
        let errorMsg;
        let title = "Error";
        let icon = "error";

        if (errorCode === "DATE.ERROR") {
          errorMsg = t(
            "forms.expeditionProcess.messages.pausedExpedition.dateError",
          );
        } else {
          errorMsg = t(
            "forms.expeditionProcess.messages.pausedExpedition.error",
          );
        }

        showDialog(title, errorMsg, icon, false, "OK", false);
      }
    };

    const cancelAction = () => {};

    showDialog(
      title,
      text,
      "warning",
      true,
      t("forms.expeditionProcess.dialog.pausedExpedition.buttonOk"),
      false,
      okAction,
      t("forms.expeditionProcess.dialog.pausedExpedition.buttonNo"),
      cancelAction,
    );
  };

  return (
    <>
      <div className="row justify-content-center mt-4 mt-md-5">
        <div className="col-12 col-md-11">
          <h3 className="title">{t(`forms.expeditionDetail.title`)}</h3>
        </div>
      </div>
      <Breadcrumb items={breads} />
      <div className="row justify-content-center mt-4 ">
        <div className="col-12 col-md-11  ">
          <div className="row">
            {/* <div
              className={
                data?.status === PROCESS_EXPEDITION_OPEN.code
                  ? "col-6"
                  : "col-12"
              }
            > */}
            <div className="col-12">
              <ExpeditionProcessDetailView
                data={data}
                onCancel={handlerOnCancel}
                // onSave={handlerOnSave}
                finish={handlerOnFinish}
                onDelete={handleDelete}
                init={handlerOnInit}
                pausedExpedition={handlerOnPausedExpedition}
                // exportToExcel={exportToExcel}
              />
            </div>
          </div>
        </div>
        {data?.status === PROCESS_EXPEDITION_OPEN.code && (
          <>
            <div className="col-12 col-md-11 border  p-5">
              <div className=" row col-12">
                <TitleJunction className="col-6 col-md-6 ">
                  <div className="d-flex">
                    {t("forms.expeditionDetail.addBB")}
                  </div>
                </TitleJunction>
                <div className="col-6 text-end">
                  <button
                    type="button"
                    className="btn btn-md btn-primary"
                    onClick={() => handlerOnSave()}
                  >
                    {t("forms.expeditionDetail.buttons.addBB")}
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-12 ">
                <InputPassObjects
                  key={resetKey}
                  objectsPassed={items}
                  onChange={handleStocksChange}
                />
              </div>
            </div>
          </>
        )}
        {data?.status === PROCESS_EXPEDITION_STARTED.code && (
          <>
            <div className="col-md-11 border p-5">
              {simpleReadBigBag(true, true, setRefresh)}
            </div>

            <div className=" row col-md-11"></div>
          </>
        )}
      </div>
      <div className="row justify-content-center mt-4 mb-5">
        <div className="col-12 col-md-11 text-center">
          <button
            type="button"
            onClick={() => handlerBack()}
            className="btn btn-lg btn-secondary me-3"
          >
            <i className="fa-solid fa-angles-left iconButton"></i>
            {t("forms.process.buttons.back")}
          </button>
        </div>
      </div>
    </>
  );
};

InventaryDetailContainer.propTypes = {};

export default InventaryDetailContainer;
